import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { Database } from '../Components/Organisms/Database/Database'

/**
 * Routed Database settings page.
 */
@Route(RouteID.DATABASE)
export class DatabasePage extends Component {
    /**
     * Renders the guarded routed page.
     *
     * @returns Database page component tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.DATABASE}>
                <LanguageContextProvider>
                    <Database />
                </LanguageContextProvider>
            </RouteGuard>
        )
    }
}
